import { render, staticRenderFns } from "./DefferedPayments.vue?vue&type=template&id=0d810b9b&scoped=true&"
import script from "./DefferedPayments.vue?vue&type=script&lang=ts&"
export * from "./DefferedPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d810b9b",
  null
  
)

export default component.exports